import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import "./HelpQueryPopup.css";
import QueryIcon from "../../images/query_icon.png";
import { useContext } from "react";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useNavigate } from "react-router-dom";
import { LoginContext } from "../../context/LoginContext";
import { driveService } from "../../services/DriveService";
import { fetchEnum } from "../../apis/enum";
import { toast } from "../../utils/toast";
import { queryService } from "../../services/QueryService";
import { messageService } from "../../services/MessageService";
import apiConfig from "../../config/apiConfig";
import { apiFetch } from "../../apis/apiFetch";

interface HelpQueryPopupProps {
    show: boolean;
    onClose: () => void;
    selectedEmails: any
    setIsSendingEmail: React.Dispatch<React.SetStateAction<any>>
}

interface FormData {
    name: string;
    category: string;
    form: string;
    description: string;
}

export default function SendEmail({
    show,
    onClose,
    selectedEmails,
    setIsSendingEmail,
    onSuccess
}: HelpQueryPopupProps & { onSuccess?: () => void }) {
    const [loading, setLoading] = useState(false);

    const [quillMsg, setQuillMsg] = useState("")
    const [subject, setSubject] = useState("")

    if (!show) return null;

    //   const handleSubmit = async (e: React.FormEvent) => {
    //     e.preventDefault();

    //     if (!formData.name || !formData.category || !formData.form || !formData.description) {
    //       toast.error("Please fill in all required fields.");
    //       return;
    //     }

    //     if (photoError) {
    //       toast.error("Please fix the photo size error before saving.");
    //       return;
    //     }

    //     setLoading(true);

    //     try {
    //       const userId = user?.userId || "";
    //       if (!userId) {
    //         toast.error("User not identified. Please log in again.");
    //         setLoading(false);
    //         return;
    //       }

    //       // Step 1: Create Query
    //       const queryObj: Record<string, string> = {
    //         subject: formData.name,
    //         category: formData.category,
    //         status: "Open",
    //         user_id: userId,
    //         drive_id: formData.form,
    //       };

    //       const jsonString = JSON.stringify(queryObj);
    //       const base64Encoded = btoa(unescape(encodeURIComponent(jsonString)));
    //       const queryParams = new FormData();
    //       queryParams.append("resource", base64Encoded);

    //       const queryResponse = await queryService.create({
    //         params: queryParams,
    //       });

    //       if (queryResponse.errCode === -1) {
    //         setLoading(false);
    //         return;
    //       }

    //       const queryId = queryResponse.resource[0]?.id;

    //       // Step 2: Create First Message
    //       const messageObj: Record<string, string> = {
    //         sendertype: "Student",
    //         message: formData.description,
    //         query_Id: queryId,
    //         user_id: userId,
    //       };

    //       const messageParams = new FormData();

    //       let selectedFile = null;
    //       selectedFile = Object.keys(dataToSave).filter((key) => dataToSave[key] instanceof File);
    //       if (selectedFile !== undefined && selectedFile.length > 0) {
    //         messageParams.append("photo", dataToSave[selectedFile[0]]);
    //         dataToSave[selectedFile[0]] = "";

    //         messageParams.append("description", "message attachment");
    //         messageParams.append("appId", "admission-iiitb");
    //         messageParams.append("dmsRole", "admin");
    //         messageParams.append("user_id", userId);
    //         messageParams.append("tags", "t1,t2,attend");
    //       }

    //       const msgJsonString = JSON.stringify(messageObj);
    //       const msgBase64Encoded = btoa(unescape(encodeURIComponent(msgJsonString)));
    //       messageParams.append("resource", msgBase64Encoded);

    //       const messageResponse = await messageService.create({
    //         params: messageParams,
    //       });

    //       if (messageResponse.errCode === -1) {
    //         setLoading(false);
    //         return;
    //       }

    //       toast.success("Query submitted successfully!");

    //       // Reset form
    //       setFormData({ name: "", category: "", form: "", description: "" });
    //       openMyQueries();
    //       onClose();
    //     } catch (error) {
    //       console.error("Error submitting query:", error);
    //       toast.error("Failed to submit query. Please try again.");
    //     } finally {
    //       setLoading(false);
    //     }
    //   };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        setIsSendingEmail(true);
        setLoading(true);

        const msg = quillMsg;
        const sub = subject;
        
        let successCount = 0;
        let failedCount = 0;
        const BATCH_SIZE = 30;

        try {
            for (let i = 0; i < selectedEmails.length; i += BATCH_SIZE) {
                const batch = selectedEmails.slice(i, i + BATCH_SIZE);
                const emailIds = batch.join('|');
                
                try {
                    const payload = {
                        email_msg: msg,
                        email_sub: sub,
                        email_ids: emailIds
                    };
                    const url = `${apiConfig.API_BASE_URL}/custom_email/sendEmail`;
                    const response = await apiFetch(url, { 
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(payload)
                    });
                    const res = await response.json();

                    if (res?.errCode === 0) {
                        successCount += batch.length;
                    } else {
                        failedCount += batch.length;
                    }
                } catch (err) {
                    console.error(err);
                    failedCount += batch.length;
                }
                await new Promise((res) => setTimeout(res, 300));
            }

            toast.success(`Sent ${successCount} emails successfully.`);
            if (successCount > 0 && onSuccess) {
                onSuccess();
            }
            if (failedCount > 0) {
                toast.error(`${failedCount} emails failed to send.`);
            }
        } catch (err) {
            console.error("Sending emails failed", err);
            toast.error("An error occurred while sending emails.");
        } finally {
            setIsSendingEmail(false);
            setLoading(false);
            onClose();
        }
    };

    return (
        <div className="help-popup-overlay" onClick={onClose}>
            <div className="help-popup-content" onClick={(e) => e.stopPropagation()}>
                <div className="help-popup-header">
                    <div className="query-header-tabs">
                        <h2>Send Email ({selectedEmails?.length || 0})</h2>
                        <div className="closeBox">
                            <button className="help-popup-close" onClick={onClose}>
                                <X size={20} />
                            </button>
                        </div>
                    </div>
                </div>

                <form className="help-query-form" onSubmit={handleSubmit}>
                    <div className="help-form-row">
                        <div className="help-field">
                            <label>Email Subject*</label>
                            <input
                                type="text"
                                name="name"
                                placeholder="Enter email subject"
                                value={subject}
                                onChange={(e) => setSubject(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="help-field">
                        <label>Email Message*</label>
                        <ReactQuill
                            theme="snow"
                            id="description"
                            value={quillMsg}
                            placeholder="Enter email message"
                            onChange={setQuillMsg} />
                    </div>

                    <div className="help-submit">
                        <button type="submit" disabled={loading}>
                            {loading ? "Submitting..." : "Submit"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
